<template>
  <filter-bar
    label="Completed Pipeline"
    :filter-text="filterText"
    :reset="resetFilters"
    has-refresh-button
    :refresh="refresh"
  >
    <filter-item v-if="this.$store.getters.authUser.can_access_all_leads">
      <filter-users
        store-module="completedState"
        filter-name="completed"
        @change="changeUserFilter"
      ></filter-users>
    </filter-item>

    <filter-item>
      <filter-statuses
        store-module="completedState"
        filter-name="completed"
        @change="changeStatusesFilter"
        statuses-name="completedStatusesInView"
      ></filter-statuses>
    </filter-item>

    <filter-item>
      <filter-campaigns
        store-module="completedState"
        filter-name="completed"
        @change="changeCampaignFilter"
      ></filter-campaigns>
    </filter-item>

    <filter-item>
      <filter-temperatures
        store-module="completedState"
        filter-name="completed"
        @change="changeTemperatureFilter"
      ></filter-temperatures>
    </filter-item>

    <filter-item>
      <filter-deal-probability-score
        store-module="completedState"
        filter-name="completed"
        @change="changeDealProbabilityFilter"
      ></filter-deal-probability-score>
    </filter-item>
  </filter-bar>
</template>

<script>
export default {
  name: "CompletedFilters",
  props: {
    refresh: {
      type: Function,
      default: () => {
      }
    }
  },
  data() {
    return {
      usersFilterText: null,
      statusesFilterText: null,
      campaignsFilterText: null,
      temperaturesFilterText: null,
      dealProbabilityScoreText: null,
    };
  },
  computed: {
    filterText() {
      let array = [];

      if (this.usersFilterText) array.push(this.usersFilterText);
      if (this.statusesFilterText) array.push(this.statusesFilterText);
      if (this.campaignsFilterText) array.push(this.campaignsFilterText);
      if (this.temperaturesFilterText) array.push(this.temperaturesFilterText);
      if (this.dealProbabilityScoreText) array.push(this.dealProbabilityScoreText);

      return array.join(" | ");
    }
  },
  methods: {
    changeUserFilter(event) {
      this.usersFilterText = event;
      this.refresh()
    },
    changeStatusesFilter(event) {
      this.statusesFilterText = event;
      this.refresh()
    },
    changeCampaignFilter(event) {
      this.campaignsFilterText = event;
      this.refresh()
    },
    changeTemperatureFilter(event) {
      this.temperaturesFilterText = event;
      this.refresh()
    },
    changeDealProbabilityFilter(event) {
      this.dealProbabilityScoreText = event;
      this.refresh()
    },
    resetFilters() {
      this.usersFilterText = null;
      this.statusesFilterText = null;
      this.campaignsFilterText = null;
      this.temperaturesFilterText = null;
      this.dealProbabilityScoreText = null;

      this.$store.commit("completedState/resetFilters", "completed");
    },
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../../styles/variables/variables";

.filter_bar {
  padding-right: $defaultGap + 16px!important;
}
</style>
